import { motion } from "framer-motion";
import { RotateCcw } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import FloatingCart from "@/components/layout/FloatingCart";
import FloatingWhatsApp from "@/components/layout/FloatingWhatsApp";
import SEOHead from "@/components/SEOHead";
import { useLanguage } from "@/context/LanguageContext";

const Returns = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <SEOHead title={`${t.returns.title} — Bait Al-Teeb`} description="Returns and exchange policy for Bait Al-Teeb fragrances." />
      <Navbar />
      <FloatingCart />
      <FloatingWhatsApp />

      <main className="pt-28 pb-20">
        <div className="container-luxury max-w-3xl">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-12">
            <span className="text-primary text-sm tracking-[0.3em] uppercase">{t.returns.badge}</span>
            <h1 className="text-4xl md:text-5xl font-serif mt-4 flex items-center justify-center gap-3">
              <RotateCcw className="w-8 h-8 text-primary" />
              {t.returns.title}
            </h1>
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} className="space-y-8">
            {t.returns.sections.map((section: any, index: number) => (
              <div key={index} className="bg-card border border-border rounded-sm p-8">
                <h2 className="font-serif text-xl mb-4 text-primary">{section.title}</h2>
                <p className="text-muted-foreground leading-relaxed">{section.content}</p>
              </div>
            ))}
          </motion.div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Returns;
